module.exports = __webpack_public_path__ + "static/Logo_SRV_Grau-522519ac5d465dafedb1f8ceae5074e5.svg";